const team_data = [
  {
    id:1,
    img:'/assets/img/team/02.png',
    name:'Eric',
    designation:'Artist',
    social_links: [
      { link: 'http://twitter.com', icon: 'fab fa-twitter', name: 'Twitter' },
      { link: 'https://www.instagram.com/', icon: 'fab fa-instagram', name: 'Instagram' },
      { link: 'https://discord.com/', icon: 'fab fa-discord', name: "Discord" },
    ],
  },
  {
    id:2,
    img:'/assets/img/team/03.png',
    name:'Sara',
    designation:'Blockchain',
    social_links: [
      { link: 'http://twitter.com', icon: 'fab fa-twitter', name: 'Twitter' },
      { link: 'https://www.instagram.com/', icon: 'fab fa-instagram', name: 'Instagram' },
      { link: 'https://discord.com/', icon: 'fab fa-discord', name: "Discord" },
    ],
  },
  {
    id:3,
    img:'/assets/img/team/01.png',
    name:'Marc',
    designation:'Developer',
    social_links: [
      { link: 'http://twitter.com', icon: 'fab fa-twitter', name: 'Twitter' },
      { link: 'https://www.instagram.com/', icon: 'fab fa-instagram', name: 'Instagram' },
      { link: 'https://discord.com/', icon: 'fab fa-discord', name: "Discord" },
    ],
  },
  {
    id:4,
    img:'/assets/img/team/04.png',
    name:'Doris',
    designation:'Artist',
    social_links: [
      { link: 'http://twitter.com', icon: 'fab fa-twitter', name: 'Twitter' },
      { link: 'https://www.instagram.com/', icon: 'fab fa-instagram', name: 'Instagram' },
      { link: 'https://discord.com/', icon: 'fab fa-discord', name: "Discord" },
    ],
  },
  {
    id:5,
    img:'/assets/img/team/05.png',
    name:'Aron',
    designation:'Artist',
    social_links: [
      { link: 'http://twitter.com', icon: 'fab fa-twitter', name: 'Twitter' },
      { link: 'https://www.instagram.com/', icon: 'fab fa-instagram', name: 'Instagram' },
      { link: 'https://discord.com/', icon: 'fab fa-discord', name: "Discord" },
    ],
  },
  {
    id:6,
    img:'/assets/img/team/06.png',
    name:'Aron',
    designation:'Manager',
    social_links: [
      { link: 'http://twitter.com', icon: 'fab fa-twitter', name: 'Twitter' },
      { link: 'https://www.instagram.com/', icon: 'fab fa-instagram', name: 'Instagram' },
      { link: 'https://discord.com/', icon: 'fab fa-discord', name: "Discord" },
    ],
  },
]

export default team_data;